module.exports = __webpack_public_path__ + "img/avatar_1.d85f17b9.png";